module.exports = __webpack_public_path__ + "static/circle-e642c80c5145c6bad6bdfd86b2e75a55.png";